import PropTypes from "prop-types";
import { gql } from "@apollo/client";

const fragments = {
  query: gql`
    fragment ShipmentQuery on Shipment {
      id
      invoiceNumber
      resendableSyncItem {
        id
        type
        flow
        syncId
      }
    }
  `,
  object: PropTypes.shape({
    id: PropTypes.number.isRequired,
    invoiceNumber: PropTypes.string
  })
};

export default fragments;
